import { Handler } from '@kollective-frontend/ksdk-api';

// This is a subset of HTMLMediaElement, with only the information we need
// required.
// https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement
export interface AttachableElement {
  addEventListener: (name: string, handler: Handler<unknown>) => void;
  removeEventListener?: (name: string, handler?: Handler<unknown>) => void;
  playbackRate: number;
  duration: number;
  currentTime: number;
  muted?: boolean;
  paused?: boolean;
  seeking?: boolean;
}

type MaybeHTMLMediaElement = HTMLMediaElement | undefined;

function isAttachableElement(obj: unknown): obj is AttachableElement {
  const v = obj as AttachableElement;
  return (
    v &&
    typeof v.addEventListener === 'function' &&
    typeof v.playbackRate === 'number' &&
    typeof v.duration === 'number' &&
    typeof v.currentTime === 'number'
  );
}

type PlayerElement = HTMLMediaElement | AttachableElement;

/**
 * return the object as an HTMLMediaElement if it is a PlayerElement
 *
 * @param obj - the object to test.
 * @returns undefined if the item is not an AttachableElement or a
 * HTMLMediaElement otherwise return the item typed to be an HTMLMediaElement
 */
export function playerElementAsMaybeMediaElement(
  obj: unknown
): MaybeHTMLMediaElement {
  return isAttachableElement(obj) ? (obj as HTMLMediaElement) : undefined;
}

export default PlayerElement;
